import Vue from 'vue'
import Vuex from 'vuex'
import notification from '@/store/notification'
import { isArray } from '@/helpers/helpers'

Vue.use(Vuex)

let initialState = {}

const state = {
  policies: null,
  signature: {
    step: 'idle',
    files: [],
    resultData: null
  },
  certificate: {
    step: 'idle',
    files: [],
    resultData: null
  },
  activeTab: 0
}

const actions = {
  saveInitialState ({ commit, state }) {
    commit('SAVE_INITIAL_STATE', state)
  },
  loadInitialState ({ commit }) {
    if (Object.keys(initialState).length) {
      // initialState был записан хотя бы раз
      commit('RESET_STATE')
    }
  },
  resetStateByType ({ commit }, type) {
    commit('RESET_STATE_BY_TYPE', type)
  },
  savePolicies ({ commit }, data) {
    commit('SAVE_POLICIES', data)
  },
  saveInitialFiles ({ commit }, { type, files }) {
    commit('SAVE_INITIAL_FILES', { type, files })
  },
  saveMoreCertificates ({ commit }, files) {
    commit('SAVE_MORE_CERTIFICATES', files)
  },
  deleteCertificate ({ commit }, id) {
    commit('DELETE_CERTIFICATE', id)
  },
  changeStep ({ commit }, { type, step }) {
    commit('CHANGE_STEP', { type, step })
  },
  resultDataSave ({ commit }, { type, data }) {
    if (type === 'signature' && data === null) {
      commit('RESULT_DATA_SAVE', { type: 'signature', data: null })
      return
    }

    if ((type === 'signature' && isArray(data?.data?.Results)) || type === 'certificate') {
      commit('RESULT_DATA_SAVE', { type, data })
    } else {
      console.warn('Попытка сохранить данные результатов в store. Но структура не соответствует ожидаемой')
    }
  },
  changeTab ({ commit }, tab) {
    commit('CHANGE_TAB', tab)
  }
}

const mutations = {
  SAVE_INITIAL_STATE (state, newState) {
    initialState = JSON.parse(JSON.stringify(newState))
  },
  RESET_STATE () {
    store.replaceState(JSON.parse(JSON.stringify(initialState)))
  },
  RESET_STATE_BY_TYPE (state, type) {
    state[type] = {
      step: 'idle',
      files: [],
      resultData: null
    }
  },
  SAVE_POLICIES (state, policies) {
    state.policies = policies
  },
  SAVE_INITIAL_FILES (state, { type, files }) {
    if (!files) {
      state[type].files = []
      return
    }

    state[type].files = [...files]
  },
  SAVE_MORE_CERTIFICATES (state, files) {
    if (state.certificate.files.length) {
      state.certificate.files = state.certificate.files.concat([...files])
    } else {
      state.certificate.files = [...files]
    }
  },
  DELETE_CERTIFICATE (state, id) {
    if (id !== undefined && id >= 0) {
      state.certificate.files.splice(id, 1)
    } else {
      state.certificate.files = []
    }
  },
  CHANGE_STEP (state, { type, step }) {
    state[type].step = step
  },
  RESULT_DATA_SAVE (state, { type, data }) {
    state[type].resultData = data
  },
  CHANGE_TAB (state, tab) {
    state.activeTab = tab
  }
}

const getters = {
  policiesIsLoaded (state) {
    return state.policies === null
      ? null
      : !!(state.policies?.SignatureDescriptions)
  }
}

const store = new Vuex.Store({
  state,
  actions,
  mutations,
  getters,
  modules: {
    notification
  }
})

export default store
